/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRankConfiguration } from '../../models/user-rank-configuration';

export interface UserRankConfiguration$Params {
}

export function userRankConfiguration(http: HttpClient, rootUrl: string, params?: UserRankConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRankConfiguration>> {
  const rb = new RequestBuilder(rootUrl, userRankConfiguration.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRankConfiguration>;
    })
  );
}

userRankConfiguration.PATH = '/user-rank/configuration';
